import { render, staticRenderFns } from "./registrado.vue?vue&type=template&id=5957e947&"
import script from "./registrado.vue?vue&type=script&lang=js&"
export * from "./registrado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports